import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { filterBusinessRoles } from '../../../helpers/role.helpers';
import {
  fullName as userFullName,
  initials as userInitials,
} from '../../../helpers/user.helpers';
import { AuthService } from '../../../services/auth.service';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { TPipe } from '../../../pipe/t.pipe';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [
    CommonModule,
    RouterModule,
    DropdownComponent,
    DropdownItemTwoComponent, TPipe],
})
export class UserDropdownComponent {
  private readonly auth = inject(AuthService);

  /** Reactive user info from AuthService (populated after /me). */
  readonly user = this.auth.user;

  /** Two-letter initials used as avatar fallback when avatarUrl is empty. */
  readonly initials = computed(() => userInitials(this.user()));

  /** Full display name (for tooltip/aria). */
  readonly fullName = computed(() => userFullName(this.user()));

  /** Short label for the topbar button (first name, fallback to username/email). */
  readonly shortLabel = computed(() => {
    const u = this.user();
    return u?.firstName || u?.username || u?.email || '';
  });

  /** Roles to display as badges in the dropdown header (business roles only). */
  readonly displayRoles = computed(() => filterBusinessRoles(this.user()?.roles));

  isOpen = false;

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  closeDropdown(): void {
    this.isOpen = false;
  }

  signOut(): void {
    this.closeDropdown();
    this.auth.logout();
  }
}
